import React from "react";
import { FormBuilderElementsMappingService } from "../../../../services/builder/form-builder.elements-mapping.service";
import { useFormData } from "../../../../hooks/client/use-form-data";
const FormBuilderFormInterfaceConsent = ({ item, analyticForm, t }) => {
  if (!item) return null;
  const { formData } = useFormData();
  const { input: checkbox, a, label, ["#text"]: text } = FormBuilderElementsMappingService.getSingleElementHTMLTags(
    item
  );
  const defaultChecked = (formData == null ? void 0 : formData[checkbox.name]) === checkbox.value;
  const onFocus = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(checkbox.name);
  };
  const onBlur = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputBlurred(checkbox.name);
  };
  return /* @__PURE__ */ React.createElement("div", { className: `${item.class}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: checkbox == null ? void 0 : checkbox.type,
      name: checkbox == null ? void 0 : checkbox.name,
      onFocus,
      onBlur,
      id: checkbox == null ? void 0 : checkbox.id,
      required: checkbox == null ? void 0 : checkbox.required,
      defaultChecked,
      value: checkbox.value ? checkbox.value : ""
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: label.for }, text && `${t(text == null ? void 0 : text.nodeValue)} `, a && /* @__PURE__ */ React.createElement("a", { href: a == null ? void 0 : a.href, target: "_blank", rel: "noopener noreferrer" }, t(a == null ? void 0 : a.nodeValue))));
};
FormBuilderFormInterfaceConsent.displayName = "FormBuilderFormInterfaceConsent";
export default FormBuilderFormInterfaceConsent;
